<mat-selection-list [formControl]="kontroller()" [multiple]="tillatVelgFlere()" [hideSingleSelectionIndicator]="false" [attr.aria-labelledby]="ariaLabelledBy()" [attr.aria-label]="ariaLabel()" data-testid="soekeresultatListing">
  @for (moeteinfo of tilgjengeligeMoeter(); track moeteinfo.moete.id) {
    <mat-list-option [value]="moeteinfo" togglePosition="before">
      <span matListItemTitle>
        {{ moeteinfo.moete.tittel }} {{ moeteinfo.moete.nummer }}, {{ moeteinfo.moete.dato.start| zoneddatetimeSomPlaindate | plaindate }}
      </span>
      <span matListItemLine>
        {{ 'protokollstatus:'|translate }} {{ moeteinfo.protokolSigneringStatus | enum:'SigneringStatus' }}
        @if (moeteinfo.protokollErTilBehandling) {
          <div class="behandlinger">
            <span>{{ 'Protokollen behandles allerede i '|translate }}</span>
            <ul>
              @for (sak of moeteinfo.protokollBehandlesI; track sak.id) {
                <li matTooltip="{{'Sak {nummer} {tittel}' |translate: {nummer: sak.nummer, tittel: sak.tittel} }}">
                  {{ sak.moete.tittel }} {{ sak.moete.nummer }}, {{ sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate }}
                </li>
              }
            </ul>
          </div>
        }
      </span>
    </mat-list-option>
  }
</mat-selection-list>

